import axios from 'axios';

const baseURL = 'https://api.opencurtainscasting.com/user';

// Send the Email for OTP
const sendEmailForOTP = async (email) => {
  try {
    const url = `${baseURL}/sendOTP`;
    const response = await axios.post(
      url,
      { email },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    // console.log('Email sent successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error(
      'Error sending email:',
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export { sendEmailForOTP };

//validateOTP function to send OTP
const validateOTP = async (otp, email) => {
  try {
    const url = `${baseURL}/validateOtp`;
    const response = await axios.post(url, { enteredOTP: otp, email });

    // console.log('OTP validated successfully:', response.data);

    return response.data;
  } catch (error) {
    console.error(
      'Error validating OTP:',
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export { validateOTP };

//resetPassword function to reset the password
export const ChangePasswordEmail = async (email, newPassword) => {
  try {
    const response = await axios.put(
      'https://api.opencurtainscasting.com/user/ChangePasswordWithEmail',
      {
        email,
        newPassword,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error changing password:',
      error.response ? error.response.data : error
    );
    throw error; // Rethrow error to handle it in the component
  }
};
